/* import __COLOCATED_TEMPLATE__ from './request-install-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();